/* src/app/components/game-layer/character-info-component/character-info-component.css */
.character-sheet {
  display: block;
}
.character-sheet-actions {
  justify-content: flex-start;
  margin-bottom: 18px;
}
.head {
  display: flex;
  align-items: center;
  gap: 30px;
  margin-bottom: 28px;
  padding: 22px;
  border: 1px solid var(--line);
  border-radius: var(--radius-lg);
  background:
    radial-gradient(
      circle at top right,
      rgba(212, 175, 55, 0.1),
      transparent 26%),
    linear-gradient(
      180deg,
      rgba(67, 45, 31, 0.9) 0%,
      rgba(30, 23, 19, 0.96) 100%);
  box-shadow: var(--shadow);
}
.inputs-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
  flex: 1;
}
.character-image {
  width: 200px;
  height: 140px;
  object-fit: contain;
  border-radius: 12px;
  border: 3px solid rgba(240, 215, 122, 0.58);
  background: rgba(255, 255, 255, 0.04);
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.3);
}
.name-input,
.role-input {
  display: block;
  font-weight: 700;
  padding: 14px 18px;
  border-radius: 12px;
  min-width: 300px;
}
.name-input {
  font-size: 1.75rem;
  color: #2a190e;
  background:
    linear-gradient(
      135deg,
      #f7ecd1 0%,
      #e5cf95 100%);
  border: 1px solid rgba(139, 109, 40, 0.6);
}
.role-input {
  font-size: 1.2rem;
  color: #f7edd1;
  background:
    linear-gradient(
      180deg,
      rgba(35, 54, 42, 0.96) 0%,
      rgba(22, 36, 29, 0.98) 100%);
  border: 1px solid rgba(112, 154, 118, 0.24);
}
.character-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  color: var(--ink-soft);
}
.character-meta span {
  padding: 8px 12px;
  border-radius: 999px;
  border: 1px solid rgba(240, 215, 122, 0.12);
  background: rgba(255, 255, 255, 0.04);
}
.stats-wrapper {
  display: flex;
  gap: 30px;
  align-items: flex-start;
}
.stats {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  padding: 22px;
  align-items: flex-start;
  align-content: flex-start;
  flex: 1;
  border: 1px solid var(--line);
  border-radius: var(--radius-lg);
  background:
    radial-gradient(
      circle at top right,
      rgba(212, 175, 55, 0.08),
      transparent 28%),
    linear-gradient(
      180deg,
      rgba(67, 45, 31, 0.82) 0%,
      rgba(30, 23, 19, 0.94) 100%);
  box-shadow: var(--shadow);
}
.bond-wrapper {
  display: contents;
}
.bond-stat-sidebar,
.hp {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  padding: 20px;
  min-width: 180px;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow);
}
.bond-stat-sidebar {
  border: 1px solid rgba(255, 192, 169, 0.16);
  background:
    linear-gradient(
      180deg,
      rgba(143, 47, 47, 0.96) 0%,
      rgba(96, 26, 26, 0.98) 100%);
}
.hp {
  margin-top: 20px;
  border: 1px solid rgba(112, 154, 118, 0.22);
  background:
    linear-gradient(
      180deg,
      rgba(41, 64, 51, 0.96) 0%,
      rgba(24, 40, 31, 0.98) 100%);
}
.hp-label,
.bond-label {
  margin: 0;
  font-size: 0.78rem;
  font-weight: 700;
  color: #fff4d1;
  text-transform: uppercase;
  letter-spacing: 0.12em;
}
.hp-value,
.bond-value {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.22);
}
.hp-value {
  width: 80px;
  height: 80px;
  border: 2px solid rgba(240, 215, 122, 0.38);
  border-radius: 14px;
  background:
    linear-gradient(
      135deg,
      #7eb084 0%,
      #426348 100%);
  font-size: 2rem;
  color: #f7f4e8;
}
.bond-value {
  width: 64px;
  height: 64px;
  border: 2px solid rgba(255, 240, 220, 0.7);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.14);
  font-size: 1.8rem;
  color: #fff4d1;
}
.hp-squares,
.bond-squares {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
}
.hp-square,
.bond-square {
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease,
    background 0.2s ease;
}
.hp-square {
  width: 22px;
  height: 22px;
  border: 2px solid #7eb084;
  border-radius: 4px;
  background: rgba(126, 176, 132, 0.18);
}
.bond-square {
  width: 30px;
  height: 30px;
  border: 2px solid rgba(255, 240, 220, 0.86);
  border-radius: 6px;
  background: transparent;
}
.hp-square.filled {
  background: #7eb084;
  box-shadow: 0 0 10px rgba(126, 176, 132, 0.44);
}
.bond-square.filled {
  background: #fff0dc;
  box-shadow: 0 0 10px rgba(255, 240, 220, 0.3);
}
.hp-damage-section {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}
.hp-damage-section input {
  width: 70px;
  text-align: center;
}
.stat-block {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.stat-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
.stat-value-square {
  width: 84px;
  height: 84px;
  display: flex;
  align-items: center;
  justify-content: center;
  background:
    linear-gradient(
      135deg,
      #d4af37 0%,
      #aa8c2c 100%);
  border: 2px solid rgba(139, 109, 40, 0.82);
  border-radius: 12px;
  font-size: 2rem;
  font-weight: 700;
  color: #2c1810;
  box-shadow: 0 10px 18px rgba(0, 0, 0, 0.22);
}
.stat-name {
  margin: 0;
  font-size: 0.85rem;
  font-weight: 700;
  color: #f3e7c0;
  text-align: center;
  max-width: 84px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}
.stats-actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-top: 18px;
  width: 100%;
  border-top: 1px solid var(--line);
  margin-top: 10px;
  color: var(--ink-soft);
}
.inventory {
  padding: 22px;
  border-radius: var(--radius-lg);
  border: 1px solid var(--line);
  background:
    radial-gradient(
      circle at top right,
      rgba(212, 175, 55, 0.08),
      transparent 28%),
    linear-gradient(
      180deg,
      rgba(67, 45, 31, 0.82) 0%,
      rgba(30, 23, 19, 0.94) 100%);
  margin-top: 20px;
  box-shadow: var(--shadow);
}
.inventory > div {
  margin-bottom: 10px;
}
.attack-block {
  padding: 12px 14px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(240, 215, 122, 0.12);
  border-left: 4px solid var(--gold);
  border-radius: 10px;
  margin-bottom: 10px;
}
.item-row {
  display: block;
}
.attack-name {
  display: block;
  font-size: 0.95rem;
  color: var(--ink);
  flex: 1;
}
.validation-text {
  margin: 0 0 14px;
  color: #ffb8a2;
}
@media (max-width: 900px) {
  .head,
  .stats-wrapper {
    flex-direction: column;
  }
  .character-image,
  .inputs-container,
  .name-input,
  .role-input {
    width: 100%;
    min-width: 0;
  }
  .bond-stat-sidebar,
  .hp {
    width: 100%;
  }
}
@media (max-width: 640px) {
  .stats {
    gap: 18px;
    padding: 18px;
  }
  .stat-value-square {
    width: 74px;
    height: 74px;
    font-size: 1.7rem;
  }
  .item-row {
    display: block;
  }
}
/*# sourceMappingURL=character-info-component.css.map */
